var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCouponSaleDiscount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M16.5 11.427V13.5a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1-.75-.75v-2.073c0-.109.062-.208.158-.256v0A2.42 2.42 0 0 0 3 9v0c0-.92-.52-1.76-1.342-2.17v0a.29.29 0 0 1-.158-.257V4.5a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 .75.75v2.073a.29.29 0 0 1-.158.256l-.033.018A2.43 2.43 0 0 0 15 9v0c0 .919.519 1.76 1.341 2.17h0a.29.29 0 0 1 .159.257",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m7.072 10.928 3.75-3.75M10.874 10.688a.188.188 0 1 0 .002.375.188.188 0 0 0-.002-.376M7.124 6.938a.188.188 0 1 0 .002.375.188.188 0 0 0-.002-.375"
})));
export default SvgCouponSaleDiscount;